import { Box, Card, Grid, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import PhoneCallbackIcon from '@mui/icons-material/PhoneCallback';
import PhoneForwardedIcon from '@mui/icons-material/PhoneForwarded';
import PhoneMissedIcon from '@mui/icons-material/PhoneMissed';
import PeopleIcon from '@mui/icons-material/People';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import SpeedIcon from '@mui/icons-material/Speed';
import TimerIcon from '@mui/icons-material/Timer';
import { fmtSeg, fmtPct } from '../helpers/procesarAcuAgentes';

const KpiCard = ({ title, value, subtitle, icon: Icon, color, isDarkMode }) => (
  <Card
    variant="outlined"
    sx={{
      p: 2,
      borderRadius: 2,
      bgcolor: isDarkMode ? 'rgba(31,42,64,0.5)' : 'rgba(255,255,255,0.9)',
      borderColor: isDarkMode ? '#3d4a62' : '#e0e0e0',
      display: 'flex',
      alignItems: 'center',
      gap: 1.5,
      minHeight: 80,
    }}
  >
    <Box
      sx={{
        width: 44,
        height: 44,
        borderRadius: '12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: color + '20',
      }}
    >
      <Icon sx={{ color, fontSize: 24 }} />
    </Box>
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ fontSize: '0.7rem', display: 'block', lineHeight: 1.2 }}
      >
        {title}
      </Typography>
      <Typography variant="h6" fontWeight={700} sx={{ fontSize: '1.15rem', lineHeight: 1.3 }}>
        {value}
      </Typography>
      {subtitle && (
        <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.65rem' }}>
          {subtitle}
        </Typography>
      )}
    </Box>
  </Card>
);

const KpiCards = ({ kpis }) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  if (!kpis) return null;

  const cards = [
    {
      title: 'Total Llamadas',
      value: kpis.totalLlamadas.toLocaleString('es-AR'),
      subtitle: `${kpis.totalLlamadasAtendidas} atendidas`,
      icon: PhoneInTalkIcon,
      color: '#3b82f6',
    },
    {
      title: 'Entrantes Atendidas',
      value: kpis.totalEntrantesAtendidas.toLocaleString('es-AR'),
      subtitle: `${kpis.totalEntrantesAbandonadas} no atendidas`,
      icon: PhoneCallbackIcon,
      color: '#22c55e',
    },
    {
      title: 'Salientes Atendidas',
      value: kpis.totalSalientesAtendidas.toLocaleString('es-AR'),
      subtitle: `${kpis.totalSalientesNoAtendidas} no atendidas`,
      icon: PhoneForwardedIcon,
      color: '#8b5cf6',
    },
    {
      title: 'Transfers',
      value: `${kpis.totalTransferIn} IN / ${kpis.totalTransferOut} OUT`,
      subtitle: null,
      icon: PhoneMissedIcon,
      color: '#f59e0b',
    },
    {
      title: 'Agentes (máx. simultáneos)',
      value: kpis.maxAgentesSimultaneos,
      subtitle: `hasta ${kpis.totalAgentesUnicos} únicos`,
      icon: PeopleIcon,
      color: '#06b6d4',
    },
    {
      title: 'Utilización Promedio',
      value: fmtPct(kpis.promedioUtilizacion),
      subtitle: `Connect: ${fmtSeg(kpis.totalConnect)}`,
      icon: SpeedIcon,
      color: '#ec4899',
    },
    {
      title: 'AHT Promedio',
      value: fmtSeg(kpis.promedioAHT),
      subtitle: `${kpis.intervalos} intervalos`,
      icon: TimerIcon,
      color: '#f97316',
    },
    {
      title: 'Tiempo en Línea',
      value: fmtSeg(kpis.totalLogin),
      subtitle: `Hold: ${fmtSeg(kpis.totalHold)} | ACW: ${fmtSeg(kpis.totalACW)}`,
      icon: AccessTimeIcon,
      color: '#10b981',
    },
  ];

  return (
    <Grid container spacing={1.5}>
      {cards.map((c, i) => (
        <Grid item xs={6} sm={4} md={3} key={i}>
          <KpiCard {...c} isDarkMode={isDarkMode} />
        </Grid>
      ))}
    </Grid>
  );
};

export default KpiCards;
